import { getConditionalObject } from 'utils/data';

import { ADD_REMOVE_ICON_TYPE } from './AddRemoveIcon.constants';

export const getAddIconStyles = ({ color, width, height, borderRadius, customStyles, type }) => {
  const lineThickness = `calc(${Math.min(parseInt(width), parseInt(height))}px * 0.1)`;
  const lineLengthVertical = `calc(${height}px * 0.6)`;
  const lineLengthHorizontal = `calc(${width}px * 0.6)`;

  return {
    position: 'relative',
    width,
    height,
    padding: 0,
    borderRadius: `${borderRadius}px`,
    border: ({ palette }) => `1px solid ${color ?? palette.primary.main}`,
    transition: 'all 0.2s ease',

    '&:after, &:before': {
      content: "''",
      position: 'absolute',
      background: ({ palette }) => color ?? palette.primary.main,
      borderRadius: '1px',
    },

    ...getConditionalObject(type === ADD_REMOVE_ICON_TYPE.ADD, {
      '&:after': {
        width: lineThickness,
        height: lineLengthVertical,
        top: `calc(50% - (${lineLengthVertical} / 2))`,
        left: `calc(50% - (${lineThickness} / 2))`,
      },
    }),

    '&:before': {
      width: lineLengthHorizontal,
      height: lineThickness,
      top: `calc(50% - (${lineThickness} / 2))`,
      left: `calc(50% - (${lineLengthHorizontal} / 2))`,
    },

    ...customStyles,
  };
};
